define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/_base/underscore",
	"dojo/dom-class",
	"csi/heading/_TooltipMixin",
	"csi/heading/RefContainer",
	"csi/image/_base"
], function(array,declare,_,domClass,_TooltipMixin,RefContainer,imageBase) {
	
	return declare([RefContainer, _TooltipMixin], {
		constructor: function(/*String*/type, /*String?*/format) {
			// summary: initialize headings for tooltip
			this.addTooltipHeading("SalesPromo", {
				m_id: "Description",
				m_name: ""
			});
		},
		
		getReferencedNodes: function(/*Context*/ctx, /*Heading*/h) {
			var nodes = _.filter(ctx.cache.getChildren(ctx.getNode(), h.m_id, true),function(node) {
				return node.Active == true;
			});
			return nodes;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: preload images so tooltip is sized correctly - CSS will handle rendering of icon
			var	nodes = this.getReferencedNodes(ctx, h);
			if (nodes && nodes.length) {
				domClass.add(refNode, "csiActionIcon iconPromo");

				array.forEach(nodes, function(node) {
					imageBase.preload(imageBase.getImageSrc(node));
				});

				return true;
			}
			
			return false;
		},
		
		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*Tooltip*/tooltip) {
			// summary: generate tooltip for promo
			this.renderTooltip(tooltip, ctx, this.getReferencedNodes(ctx, h));
			tooltip.showDelay = 1;
		}
	});
});